import baseRequest from "../_core/baseRequest";

export const integratorService = {
    integratorList: params => baseRequest.get(`/integrator${baseRequest.queryString(params, {})}`),
    integratorInfo: params => baseRequest.get(`/integrator/${params.integratorId}`),
    updateIntegrator: params => baseRequest.put(`/integrator/${params.integratorId}`, params),
    createIntegrator: params => baseRequest.post(`/integrator`, params),
    patchIntegrator: params => baseRequest.patch(`/integrator/${params.integratorId}`, params),
    deleteIntegrator: params => baseRequest.delete(`/integrator/${params.integratorId}`),
};

export default integratorService;
